import React, { useState } from "react";
import "./InstructionalPanel.css";
import vector_black from "../../assets/images/Vector_black.png";
import copy from "../../assets/images/copy.png";
import bigCross from "../../assets/images/big-cross.png";

interface InstructionalPanelProps {
  isOpen: boolean;
  onClose?: () => void;
  isInternal?: boolean;
  isMaximized?: boolean;
}

const InstructionalPanel: React.FC<InstructionalPanelProps> = ({
  isOpen,
  onClose,
  isInternal = false,
  isMaximized = false,
}) => {
  const [copiedText, setCopiedText] = useState<string>("");

  if (!isOpen) return null;

  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setTimeout(() => setCopiedText(""), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopiedText(text);
      setTimeout(() => setCopiedText(""), 2000);
    }
  };

  const panelClass = `instructional-panel ${
    isInternal ? "internal-mode" : ""
  } ${isOpen ? "show" : ""} ${isMaximized ? "maximized-mode" : ""}`;

  // Dynamic addresses based on URL parameters or embed config
  const getAddressesForCommunity = () => {
    // Check current window first
    let embedCity = (window as any).__VIEWPRO_CITY__;
    
    // If not found, check if there's an iframe and look in its window
    if (!embedCity) {
      const iframe = document.querySelector('iframe[srcdoc]') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        embedCity = (iframe.contentWindow as any).__VIEWPRO_CITY__;
      }
    }
    
    // Check URL parameters (for standalone mode)
    const urlParams = new URLSearchParams(window.location.search);
    const urlAubreyCity = urlParams.has('aubrey-tx') || urlParams.get('community') === 'aubrey-tx';
    const urlBaytownCity = urlParams.has('baytown-tx') || urlParams.get('community') === 'baytown-tx';
    
    const isAubreyTx = embedCity === 'aubrey-tx' || urlAubreyCity;
    const isBaytownTx = embedCity === 'baytown-tx' || urlBaytownCity;
    
    if (isAubreyTx) {
      return ["514 Prator Ln", "308 E Sherman DR", "910 Germaine St"];
    }
    
    if (isBaytownTx) {
      return ["3422 Garth Rd", "3704 Montego Dr", "7 Gresham St"];
    }
    
    // Default addresses for other communities
    return ["125 Old Home Pl", "565 Lake Montonia Rd", "110 King St"];
  };

  const addresses = getAddressesForCommunity();

  const developmentTypes = [
    "Bed & Breakfast",
    "Convention Center",
    "Medical Office",
    "Multifamily Dwelling",
  ];

  return (
    <div className={panelClass}>
      <div className="instructional-panel-content">
        <div className="instructional-header">
          <div className="instruction-help">
            <img src={vector_black} alt="help"  className="instruction-vector"/>
            <span
              style={{ color: "black", fontSize: "20px", marginLeft: "10px" }}
            >
              Help
            </span>
          </div>

          {/* <button className="instructional-close-button" onClick={onClose}>
            x
          </button> */}
          <button
            className="control-button"
            onClick={onClose}
            title="Close disclaimer"
          >
            <div className="icon-base">
              <div className="big-cross-icon-svg"></div>
            </div>
          </button>
        </div>
        <div className="instructional-body">
          <p className="instructional-text">
            Try any of the following address when required:
          </p>

          <div className="address-examples">
            {addresses.map((address, index) => (
              <div key={index} className="address-copied">
                <p>{address}</p>
                <div
                  className="copy-icon-svg"
                  style={{
                    cursor: "pointer",
                    opacity: copiedText === address ? 0.5 : 1,
                  }}
                  onClick={() => handleCopy(address)}
                  title={
                    copiedText === address ? "Copied!" : "Copy to clipboard"
                  }
                ></div>
              </div>
            ))}
          </div>
          <p className="instructional-text">
            Here are the development types that you could consider as an input:
          </p>

          <div className="question-examples">
            {developmentTypes.map((type, index) => (
              <div key={index} className="address-copied">
                <p>{type}</p>
                <div
                  className="copy-icon-svg"
                  style={{
                    cursor: "pointer",
                    opacity: copiedText === type ? 0.5 : 1,
                  }}
                  onClick={() => handleCopy(type)}
                  title={copiedText === type ? "Copied!" : "Copy to clipboard"}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructionalPanel;
